import React from 'react';
import { Box, Typography, List, ListItem, ListItemText, ListItemIcon } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ContractIcon from '@mui/icons-material/Description';
import PrimaryButton from '../components/PrimaryButton';
import { useNavigate } from 'react-router-dom';
import routes from '../routes';

const contracts = [
  { id: 1, name: 'Contrato 1' },
  { id: 2, name: 'Contrato 2' },
  { id: 3, name: 'Contrato 3' },
];

const Contracts = () => {
  const navigate = useNavigate();

  const handleCreateContract = () => {
    navigate(routes.SELECT_PROFESSION);
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4">
        Meus contratos
      </Typography>
      <PrimaryButton
        startIcon={<AddIcon />}
        onClick={handleCreateContract}
        sx={{ mt: 2 }}
      >
        Criar novo contrato
      </PrimaryButton>
      <List sx={{ mt: 2 }}>
        {contracts.map((contract) => (
          <ListItem key={contract.id} button>
            <ListItemIcon>
              <ContractIcon />
            </ListItemIcon>
            <ListItemText primary={contract.name} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default Contracts;